import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  class: "flex",
  "aria-label": "breadcrumb"
}

import { HTMLAttributes, useSlots, provide } from "vue";

export type ProvideBeradcrumb = {
  light?: boolean;
};

interface BreadcrumbProps extends HTMLAttributes {
  light?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Breadcrumb',
  props: {
    light: { type: Boolean }
  },
  setup(__props: any) {

const { light } = __props as {
  light?: boolean;
}

const slots = useSlots();
// eslint-disable-next-line


provide<ProvideBeradcrumb>("breadcrumb", {
  light: light,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("ol", {
      class: _normalizeClass([
        'flex items-center text-primary dark:text-slate-300',
        { 'text-white/90': __props.light },
      ])
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(slots).default && _unref(slots).default(), (item, key) => {
        return (_openBlock(), _createBlock(_resolveDynamicComponent(item), {
          index: key,
          key: item
        }, null, 8, ["index"]))
      }), 128))
    ], 2)
  ]))
}
}

})